<template>
  <div 
    class="patient-card-container bg-white rounded border border-gray-200 px-5 py-3.5 w-full h-full transition-all duration-200 cursor-pointer"
    :class="{ 'selected': isSelected }"
    @click="handleClick"
  >
    <div class="flex items-center justify-between mb-1">
      <el-tooltip
        :content="name"
        placement="top"
        effect="dark"
        :disabled="!isNameOverflow"
      >
        <div class=" flex-1" style="max-width: 194px;">
          <p 
            class="patient-name-text font-medium text-base text-gray-800 m-0 truncate"
            :title="name"
          >
            {{ name }}
          </p>
        </div>
      </el-tooltip>
      <div class="w-6 h-6 flex items-center justify-center">
        <!-- Selected state - checkmark icon -->
        <img v-if="isSelected" src="@/assets/orderTest/family-discount/check_circle.svg">
        <!-- Default state - avatar circle -->
        <svg
          v-else
          class="w-5 h-5"
          fill="none"
          preserveAspectRatio="none"
          viewBox="0 0 20 20"
        >
          <circle
            class="avatar-circle"
            cx="10"
            cy="10"
            fill="#F2F2F2"
            r="9.5"
            stroke="#C9CACD"
          />
        </svg>
      </div>
    </div>
    <div class="patient-details flex items-center gap-1 text-sm text-gray-600">
      <span v-if="gender">{{ gender }}</span>
      <span v-if="birthDate">|</span>
      <span v-if="birthDate">{{ formattedDate }}</span>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  emits: ["click"],
  name: 'PatientCard',
  props: {
    id: {
      type: Number,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    gender: {
      type: String,
      default: null
    },
    birthDate: {
      type: String,
      default: null
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isSelected: this.selected,
      isNameOverflow: false
    };
  },
  computed: {
    formattedDate() {
      return this.birthDate ? moment(this.birthDate).format("MMM-DD-YYYY") : "";
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.isNameOverflow = this.getIsNameOverflow();
    });
  },
  methods: {
    handleClick() {
      this.isSelected = !this.isSelected;
      this.$emit('click', this.id);
    },
    getIsNameOverflow() {
      let nameElement = this.$el.getElementsByClassName('patient-name-text')[0];
      if (!nameElement) return false;
      return nameElement.scrollWidth > nameElement.clientWidth;
    }
  },
  watch: {
    selected(newVal) {
      this.isSelected = newVal;
    },
  }
}
</script>

<style scoped>
/* Custom styles for exact color matching */
.text-gray-800 {
  color: #333333;
}

.text-gray-600 {
  color: #666666;
}

.border-gray-200 {
  border-color: #e6e6e6;
}

/* Selected state styles */
.patient-card-container.selected {
  background-color: #fffdfc;
  border-color: #1e4670;
}

.patient-card-container.selected .patient-name-text {
  color: #1e4670;
}

.patient-card-container.selected .patient-details {
  color: #1e4670;
}

/* Hover effects with exact Figma colors */
.patient-card-container:hover {
  background-color: #fffdfc;
  border-color: #1e4670;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.19);
}

.patient-card-container:hover .patient-name-text {
  color: #1e4670;
}

.patient-card-container:hover .patient-details {
  color: #1e4670;
}

.patient-card-container:hover .avatar-circle {
  fill: #f9fbfd;
  stroke: #1e4670;
}
</style>
